import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';

import * as yup from 'yup';
import { valid } from 'semver';

/** Semantic Versioning (SemVer) format version number validator */
export const semVerSchema = yup
  .string()
  .test({
    name: 'sem-ver-schema',
    message: DtoMessageEnum.INVALID_SEM_VER,
    test: value => Boolean(valid(value)),
  });
